import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Vote from './views/Vote.vue';
import Event from './views/Event.vue';
import Link from './views/Link.vue';
import Game from './views/Game.vue';

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/vote',
      name: 'vote',
      component: Vote,
    },
    {
      path: '/event',
      name: 'event',
      component: Event,
    },
    {
      path: '/link',
      name: 'link',
      component: Link,
    },
    {
      path: '/game',
      name: 'game',
      component: Game,
    },
  ],
});
